export default "__VITE_ASSET__BdD7iV3o__"